module.exports = __webpack_public_path__ + "media/stylesheets/images/recruit/recruit-draft-706178ccc13e0baf693ab7f97752203f.jpg";